
















































import { NextQueries } from '@empathy/search-types';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { ComponentsConfig, EmpathyXConfig, TrackClickEvents } from '../../models';
import { SUBMODULES_PATHS } from '../../store';
import { CONFIG_GETTERS_KEYS } from '../../store/config/config.const';

@Component({
  computed: {
    ...mapGetters(SUBMODULES_PATHS.config, {
      components: CONFIG_GETTERS_KEYS.components,
      config: CONFIG_GETTERS_KEYS.config,
      nextQueryResultConfig: CONFIG_GETTERS_KEYS.nextQueryResultConfig
    })
  }
})
export default class NextQueriesComponent extends Vue {
  @Prop({ required: true })
  private item: NextQueries;

  @Prop()
  private clickEvents: TrackClickEvents;

  private components: ComponentsConfig;
  private config: EmpathyXConfig;

  get nextQueryComponent() {
    return this.config.nextQueries.withResults
      ? this.components.resultsGrid.nextQueries.withResults
      : this.components.resultsGrid.nextQueries.withoutResults;
  }

  get hasNextQueriesTitle() {
    return !!this.$x.messages.nextQueries.titleHTML;
  }
}
